import React, { useCallback, useEffect, useState } from "react";
import { BrComerceApiService } from "../../../../services/BrComerceApiService";
import styles from "./styles.module.scss";

import { Close } from "@material-ui/icons";
import { debounce } from "lodash";
import moment from "moment";
import { FiAlertCircle, FiDownload, FiEye, FiUpload } from "react-icons/fi";
import InfiniteScroll from "react-infinite-scroll-component";
import Swal from "sweetalert2";
import tooltipIcon from "../../../../assets/icons/tooltip-info.svg";
import banner from "../../../../assets/images/shipping-import.svg";
import bannerPreview from "../../../../assets/images/validate-correios-banner-preview.svg";
import tutorial1 from "../../../../assets/images/validate-correios/tutorial1.png";
import tutorial2 from "../../../../assets/images/validate-correios/tutorial2.png";
import tutorial3 from "../../../../assets/images/validate-correios/tutorial3.png";
import tutorial4 from "../../../../assets/images/validate-correios/tutorial4.png";
import tutorial5 from "../../../../assets/images/validate-correios/tutorial5.png";
import tutorial6 from "../../../../assets/images/validate-correios/tutorial6.png";
import LoadInfiniteScroll from "../../../../components/LoadInfiniteScroll";
import { Loading } from "../../../../components/Loading";
import { DragAndDrop } from "../../components/DragAndDrop";
import ScrollDiv from "../../components/ScrollDiv";
import { StyledTooltip } from "../../components/Tooltip";


const ValidateCorreios = () => {
  const api = new BrComerceApiService();

  const [loading, setLoading] = useState(false);
  const [loadingInfinit, setLoadingInfinit] = useState(false);

  const [uploadFile, setUploadFile] = useState();
  const [exports, setExports] = useState([]);

  const [hasMore, setHasMore] = useState(false);
  const [actualPage, setActualPage] = useState(1);

  const [dynamoPage, setDynamoPage] = useState(null);
  const [exportId, setExportId] = useState(0);
  const [validations, setValidations] = useState([]);
  const [hasMorePreview, setHasMorePreview] = useState(false);

  const [uploadModal, setUploadModal] = useState(false);
  const [tutorialModal, setTutorialModal] = useState(false);
  const [previewModal, setPreviewModal] = useState(false);

  const handleUpload = useCallback((file) => {
    setUploadFile(file);
  }, []);

  const handleClear = useCallback(() => {
    setUploadFile(null);
  }, []);

  const handleOpenModal = useCallback(() => {
    setUploadModal(true);
  }, []);

  const handleTutorial = useCallback(() => {
    setTutorialModal(!tutorialModal);
  }, [tutorialModal]);

  const handleOpenPreview = useCallback((id) => {
    setExportId(id);
    setPreviewModal(true);
  }, []);

  const handleClosePreview = useCallback(() => {
    setPreviewModal(false);
    setExportId(null);
    setValidations([]);
    setDynamoPage(null);
    setHasMorePreview(false);
  }, []);

  const handleCloseModal = useCallback(() => {
    setUploadModal(false);
    setUploadFile(null);
  }, []);

  const handleSubmit = useCallback(async () => {

    setLoading(true);

    if (uploadFile) {

      let data = new FormData();

      data.append("sheet", uploadFile);

      setActualPage(1);
      setHasMore(false);
      setExports([]);

      try {
        await api.makeHttpRequest({
          method: "POST",
          url: `validate-correios`,
          data,
        });
      } catch (e) {
        console.log(JSON.parse(JSON.stringify(e)));
        return Swal.fire({
          title: 'Ops!',
          text: 'Erro ao fazer upload da planilha, tente novamente mais tarde',
          icon: 'error'
        });
      } finally {
        await loadTables(1);
        setUploadModal(false);
        setLoading(false);
      }
    } else {
      setLoading(false);
      return Swal.fire({
        title: 'Planilha não encontrada!',
        text: 'Selecione o arquivo e tente novamente',
        icon: 'error'
      });
    }
  }, [uploadFile, api]);


  const loadTables = useCallback(
    debounce(async (page) => {
      try {
        setLoading(true);
        const response = await api.makeHttpRequest({
          url: '/validate-correios',
          params: {
            page: page ?? actualPage,
            resultsPerPage: 20,
          }
        });

        if (response?.length === 20) {
          setActualPage(page ? page + 1 : actualPage + 1);
          setHasMore(true);
        } else {
          setHasMore(false);
        }

        setExports(previousState => [...previousState, ...response]);
      } catch (e) {
        Swal.fire({
          text: "Erro ao carregar lista de tabelas",
          title: "Tabelas de conferência",
          icon: "error"
        });
      } finally {
        setLoading(false);
      }
    }, 500),
    [exports, actualPage]
  );

  const loadValidations = useCallback(
    debounce(async () => {
      try {
        setLoading(true);
        const response = await api.makeHttpRequest({
          method: "GET",
          url: '/validate-correios/list',
          params: {
            exportId,
            ...(dynamoPage && { page: dynamoPage }),
            resultsPerPage: 50,
          }
        });

        if (response?.nextPage) {
          setDynamoPage(response.nextPage);
          setHasMorePreview(true);
        } else {
          setDynamoPage("");
          setHasMorePreview(false);
        }
        setValidations(previousState => [...previousState, ...response.data]);
      } catch (e) {
        Swal.fire({
          title: "Algo deu errado",
          html: "Não foi possível carregar a prévia, tente novamente",
          icon: "error"
        })
      } finally {
        setLoading(false);
      }
    }, 500),
    [exportId, dynamoPage, validations]
  );

  const handleDownloadTable = async (id) => {
    try {
      setLoading(true);
      const link = await api.makeHttpRequest({
        method: "GET",
        url: `/validate-correios/${id}`
      });

      window.open(link.link, "_blank");
    } catch (e) {
      const msg = e?.response?.body?.data?.message;
      Swal.fire({
        title: "Erro!",
        text: msg || "Erro ao baixar arquivo",
        icon: "error"
      });
    } finally {
      setLoading(false);
    }
  }

  useEffect(() => {
    loadTables();
  }, []);

  useEffect(() => {
    if (exportId) {
      loadValidations()
    }
  }, [exportId]);

  useEffect(() => {
    window.setPageTitle("Validação Correios");
  }, [])

  return (
    <>
      {uploadModal && (
        <>
          <div className={styles.uploadBackground} onClick={handleCloseModal} />
          <div className={styles.uploadModal}>
            <div className={styles.close}>
              <Close onClick={handleCloseModal} />
            </div>
            <span>Faça o upload do arquivo abaixo:</span>
            <div className={styles.dragAndDrop}>
              <DragAndDrop
                onUpload={handleUpload}
                onClear={handleClear}
                fileExtension=""
              />
            </div>
            <button
              type="button"
              className={`${styles.btnSubmit} ${!uploadFile ? styles.disabled : ""}`}
              onClick={handleSubmit}
              disabled={!uploadFile}
            >
              <span>Enviar</span>
            </button>
          </div>
        </>
      )}

      {tutorialModal && (
        <>
          <div className={styles.uploadBackground} onClick={handleTutorial} />
          <div className={styles.tutorialWrapper}>
            <div className={styles.close}>
              <Close onClick={handleTutorial} />
            </div>
            <div className={styles.tutorialModal}>

              <span>Editando a planilha:</span>
              <br />
              {/* <p>
                <br />
                <b>Exclua as 2 primeiras linhas referentes aos dados de cliente Correios.</b>
                <br />
                <img
                  src={tutorial1}
                  alt="Tutorial"
                />
              </p>
              <br /> */}
              <p>
                <br />
                <b>Exclua todas as colunas deixando apenas as presentes na imagem abaixo.</b>
                <br />
                <img
                  src={tutorial4}
                  alt="Tutorial"
                />
              </p>

              <p>
                <br />
                <b>Exclua todas as linhas após o último objeto.</b> Dica: O atalho CTRL + ↓ vai te levar para o último objeto
                <br />
                <img
                  src={tutorial6}
                  alt="Tutorial"
                />
                <img
                  src={tutorial5}
                  alt="Tutorial"
                />
              </p>

              <br />
              <span>Situação:</span>
              <br />
              <p>
                <br />
                <b>OK:</b> Sem diferença de preço.
                <br />
                <b>Divergente:</b> Com diferença de preço, o motivo estará na coluna "Motivo".
                <br />
                <b>Não validado:</b> O pedido estava sem validação na BRCom e foi validado com as medidas informadas pelos Correios.
                <br />
                <b>Não encontrado:</b> O pedido não consta no banco de dados.
              </p>
              <br />
              <span>Motivos:</span>
              <br />
              <p>
                <br />
                <b>Peso divergente:</b> Há diferença entre o peso do objeto e o "Peso Real" informado pelos Correios.
                <br />
                <b>Nivel divergente:</b> O peso está igual porém foi calculado com outro nível.
                <br />
                <b>Desconhecido:</b> Não encontramos um motivo específico para a divergência.
              </p>
              <br />
              <span>Objetos deletados:</span>
              <br />
              <p>
                <br />
                Caso o objeto esteja com a coluna "Deletado" como "S", a reversão da deleção foi efetuada e o objeto foi validado usando as medidas informadas pelos Correios.
              </p>
              <br />
            </div>
          </div>
        </>
      )}

      {previewModal && (
        <>
          <div className={styles.uploadBackground} onClick={handleClosePreview} />
          <div className={styles.containerPreview}>
            <div className={styles.title}>
              <h2>{`Planilha nº ${exportId}`}</h2>
              <div className={styles.close}>
                <Close onClick={handleClosePreview} />
              </div>
            </div>
            <ScrollDiv data={validations}>
              <InfiniteScroll
                dataLength={validations.length}
                next={loadValidations}
                hasMore={hasMorePreview}
                loader={loadingInfinit && !loading && <LoadInfiniteScroll />}
                scrollableTarget="scrollDiv"
                className={styles.infiniteScroll}
              >
                {!validations?.length && !loading ?
                  <div className={styles.banner}>
                    <img
                      src={bannerPreview}
                      alt="Um desenho de uma figura feminina com um papel na mão a esquerda com telas de diversos dispostivos ao fundo na direita"
                    />
                    <span>O processamento da planilha ainda não gerou resultados</span>
                  </div>
                  :
                  <div className={styles.tableContainer}>
                    <table className={styles.table}>
                      <thead className={styles.tableHead}>
                        <tr>
                          <th>Etiqueta</th>
                          <th>Altura</th>
                          <th>Largura</th>
                          <th>Comprimento</th>
                          <th>Peso</th>
                          <th>Preço</th>
                          <th>Situação</th>
                          <th>Motivo</th>
                          <th>Origem</th>
                          <th>Destino</th>
                          <th>Agência</th>
                          <th>Serviço</th>
                        </tr>
                      </thead>
                      <tbody className={styles.tableBody}>
                        {validations?.map((item, i) => (
                          <tr key={i}>
                            <td>{item.sro}</td>
                            <td title="BRCom / Correios">{item.brcom_height <= 0 ? "-" : item.brcom_height} / {item.correios_height <= 0 ? "-" : item.correios_height}</td>
                            <td title="BRCom / Correios">{item.brcom_width <= 0 ? "-" : item.brcom_width} / {item.correios_width <= 0 ? "-" : item.correios_width}</td>
                            <td title="BRCom / Correios">{item.brcom_length <= 0 ? "-" : item.brcom_length} / {item.correios_length <= 0 ? "-" : item.correios_length}</td>
                            <td title="BRCom / Correios">{item.brcom_weight <= 0 ? "-" : item.brcom_weight} / {item.correios_weight <= 0 ? "-" : item.correios_weight}</td>
                            <td title="BRCom / Correios">{item.brcom_price <= 0 ? "-" : item.brcom_price} / {item.correios_price <= 0 ? "-" : item.correios_price}</td>
                            <td>{item.status}</td>
                            <td>{item.reason}</td>
                            <td>{item.ufOrigin}</td>
                            <td>{item.ufDestination}</td>
                            <td>{item.postOffice}</td>
                            <td>{item.service}</td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                }
              </InfiniteScroll>
            </ScrollDiv>
          </div>
        </>
      )}

      <Loading loading={loading} />
      <div className={styles.container}>
        <div className={styles.column}>
          <h1 className={styles.title}>Validação Correios</h1>
          <div className={styles.row}>
            <div className={styles.btnContainer}>
              <button
                type="button"
                className={styles.btnImport}
                onClick={handleOpenModal}
              >
                <FiUpload />
                <span>Enviar arquivo</span>
              </button>
              <button
                type="button"
                className={`${styles.btnImport} ${styles.blue}`}
                onClick={handleTutorial}
              >
                <img
                  src={tooltipIcon}
                  alt="Tooltip"
                />
                <span>Informações</span>
              </button>
              <div className={styles.tooltipIcon}>
              </div>
            </div>
          </div>
        </div>
        {
          <ScrollDiv data={exports}>
            <InfiniteScroll
              dataLength={exports.length}
              next={loadTables}
              hasMore={hasMore}
              loader={loadingInfinit && !loading && <LoadInfiniteScroll />}
              scrollableTarget="scrollDiv"
              className={styles.infiniteScroll}
            >
              <div className={styles.tableContainer}>
                <table className={styles.table}>
                  <thead className={styles.tableHead}>
                    <tr>
                      <th>
                        ID
                      </th>
                      <th>
                        Nome do arquivo
                      </th>
                      <th>
                        Progresso
                      </th>
                      <th>
                        Status
                      </th>
                      <th>
                        Data de envio
                      </th>
                      <th>
                        Ações
                      </th>
                    </tr>
                  </thead>
                  <tbody className={styles.tableBody}>
                    {exports?.map((info, i) => (
                      <tr key={i}>
                        <td>
                          {info?.id}
                        </td>
                        <td>
                          {info?.name}
                        </td>
                        <td>
                          {info?.count || "-"} / {info?.total || "-"}
                        </td>
                        <td
                          className={styles.statusSpan}
                        >
                          <span
                            style={{
                              borderRadius: "4px",
                              padding: "5px 4px",
                              backgroundColor: !!info?.s3Path ? "#5BC289" : "#F5CB2B",
                              fontWeight: 700
                            }}
                          >
                            {!!info?.s3Path ? "Concluido" : "Em processo"}
                          </span>
                        </td>
                        <td>
                          {moment(info.created_at).format('DD/MM/YYYY')}
                        </td>
                        <td className={styles.tooltipWrapper}>
                          {info.s3Path !== "processError" ?
                            <>
                              <StyledTooltip text="Fazer download" position="top" arrow>
                                <div>
                                  <FiDownload
                                    onClick={() => !!info?.s3Path ? handleDownloadTable(info.id) : ""}
                                    style={{
                                      cursor: !!info?.s3Path ? "pointer" : "default",
                                      marginRight: "5px"
                                    }}
                                    size={20}
                                    color={!!info?.s3Path ? "#409E6A" : "#B3B3B3"}
                                  />
                                </div>
                              </StyledTooltip>
                              <StyledTooltip text="Ver prévia" position="top" arrow>
                                <div>
                                  <FiEye
                                    onClick={() => handleOpenPreview(info.id)}
                                    style={{
                                      cursor: "pointer",
                                      marginRight: "5px"
                                    }}
                                    size={20}
                                    color={"#409E6A"}
                                  />
                                </div>
                              </StyledTooltip>
                            </>
                            : <>
                              <StyledTooltip text="Erro no processamento" position="top" arrow>
                                <div>
                                  <FiAlertCircle
                                    style={{
                                      marginRight: "5px"
                                    }}
                                    size={20}
                                    color={"#FF6B71"}
                                  />
                                </div>
                              </StyledTooltip>
                            </>
                          }
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
                {!loading && !loadingInfinit && exports?.length === 0 &&
                  <div className={styles.banner}>
                    <img
                      src={banner}
                      alt="Um desenho de uma figura feminina com um papel na mão a esquerda com telas de diversos dispostivos ao fundo na direita"
                    />
                    <span>Faça o upload da planilha dos Correios</span>
                  </div>
                }
              </div>
            </InfiniteScroll>
          </ScrollDiv>
        }
      </div>
    </>
  );
};

export { ValidateCorreios };
